import { ManagedProfilesPolicy } from '@oh-vcp/components-common';
import { useQuery } from 'react-query';
import { apiGet } from './apiService';

const fetchManagedProfilesPolicy = async (): Promise<ManagedProfilesPolicy> => {
  try {
    const response = await apiGet('users/managedprofiles/policy');
    return response as ManagedProfilesPolicy;
  } catch (error) {
    console.error(error);
    return {};
  }
};

const useManagedProfilesPolicy = (isEnabled: boolean) => {
  return useQuery({
    enabled: isEnabled,
    queryFn: fetchManagedProfilesPolicy,
    queryKey: ['fetchManagedProfilesPolicy'],
    retry: 0
  });
};

export default useManagedProfilesPolicy;
